/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipConsentChannel } from './HomeownershipConsentChannel';
import {
    HomeownershipConsentChannelFromJSON,
    HomeownershipConsentChannelFromJSONTyped,
    HomeownershipConsentChannelToJSON,
} from './HomeownershipConsentChannel';

/**
 * The resident withdraws their consent on one channel (TXN-3476).
 * @export
 * @interface HomeownershipConsentWithdrawRequest
 */
export interface HomeownershipConsentWithdrawRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipConsentWithdrawRequest
     */
    token: string;
    /**
     * 
     * @type {HomeownershipConsentChannel}
     * @memberof HomeownershipConsentWithdrawRequest
     */
    channel: HomeownershipConsentChannel;
}

/**
 * Check if a given object implements the HomeownershipConsentWithdrawRequest interface.
 */
export function instanceOfHomeownershipConsentWithdrawRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "channel" in value;

    return isInstance;
}

export function HomeownershipConsentWithdrawRequestFromJSON(json: any): HomeownershipConsentWithdrawRequest {
    return HomeownershipConsentWithdrawRequestFromJSONTyped(json, false);
}

export function HomeownershipConsentWithdrawRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipConsentWithdrawRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'channel': HomeownershipConsentChannelFromJSON(json['channel']),
    };
}

export function HomeownershipConsentWithdrawRequestToJSON(value?: HomeownershipConsentWithdrawRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'channel': HomeownershipConsentChannelToJSON(value.channel),
    };
}

